export default "__VITE_ASSET__Dwra3V4c__"